module.exports = __webpack_public_path__ + "static/gr-a588d7768b97acd02599cef211896623.jpg";